import React from 'react';
import PropTypes from 'prop-types';
import {formatAmount, formatLocation, formatNumber, formatRoundedNumber, uniqueFilter} from "../utils/utils";

export const Stats = React.forwardRef((props, ref) => {
    const nbEmployments = props.data.length > 0 ? props.data.map(item => item.totalEtpApres).reduce((acc, currentValue) => acc + currentValue) : 0;
    const nbEmploymentsForTroublePeople = props.data.length > 0 ? props.data.map(item => item.totalEtpEnDifficulte).reduce((acc, currentValue) => acc + currentValue) : 0;
    const amount = props.data.length > 0 ? props.data.map(item => item.totalFinancement).reduce((acc, currentValue) => acc + currentValue) : 0;
    const nbEnterprises = props.data.map(item => item.numeroStructure).filter(uniqueFilter).length;
    return (
        <div className="region-stats-block">
            <div className="regions-stats">
                <h3 tabIndex={-1} ref={ref}>
                    <span>{formatLocation(props.title, true)}</span>
                    &nbsp;
                    <sup>
                        <a className="link"
                           aria-label="Aller à la note n°9 en bas de page"
                           title="Aller à la note n°9 en bas de page"
                           href="#"
                           onClick={(e) => {
                               e.preventDefault();
                               window.parent.document.getElementById('return-id-7').click();
                           }}
                        >9</a>
                    </sup>,
                    ces 5 dernières années, grâce à l’épargne solidaire MAIF et à France&nbsp;Active&nbsp;:
                </h3>
                <div className="region-stat">
                    <p className="stat-block">
                        <span className="stat-value">{formatNumber(nbEnterprises)}</span>
                        <span className="stat-label">{formatNumber(nbEnterprises) > '1' ? ' entreprises financées ' : ' entreprise financée '}</span>
                    </p>
                    <p className="stat-block">
                        <span className="stat-value">{formatAmount(amount)}</span>
                        <span className="stat-label">{formatNumber(amount) > '1' ? ' investis dans ces entreprises ': ' investi dans ces entreprises '}</span>
                    </p>
                    <p className="stat-block">
                        <span className="stat-value">{formatRoundedNumber(nbEmployments)}</span>
                        <span className="stat-label">{formatRoundedNumber(nbEmployments) > '1'  ? ' emplois créés ' : ' emploi créé '}</span>
                        <span className="stat-additionnal">(dont {formatRoundedNumber(nbEmploymentsForTroublePeople)} pour des personnes en difficulté)</span>
                    </p>
                </div>
            </div>
        </div>
    )
});

Stats.propTypes = {
    title: PropTypes.string.isRequired,
    data: PropTypes.array.isRequired
}